import { render, staticRenderFns } from "./intro-page.vue?vue&type=template&id=7980496b&scoped=true&"
import script from "./intro-page.vue?vue&type=script&lang=js&"
export * from "./intro-page.vue?vue&type=script&lang=js&"
import style0 from "./intro-page.vue?vue&type=style&index=0&id=7980496b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980496b",
  null
  
)

export default component.exports